import logo from '../assets/logo-rapidepro.png'

// Square logo (2084x2084) — map the size prop to a fixed height, width auto.
const SIZE_CLASSES = {
  sm: 'h-10',
  default: 'h-14',
  lg: 'h-20',
}

export default function ClickProLogo({ className = '', size = 'default' }) {
  return (
    <img
      src={logo}
      alt="Rapidepro"
      className={`${SIZE_CLASSES[size] || SIZE_CLASSES.default} w-auto object-contain ${className}`}
    />
  )
}
